'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = exports.breakpoints = {
  // The grid is mobile first so xs is the default, hence no breakpoint
  xs: false,
  sm: 760,
  md: 976,
  lg: 1280,
  xl: 1600
};

var media = exports.media = function media(size) {
  var breakpoint = breakpoints[size];

  if (breakpoint) {
    return '@media only screen and (min-width: ' + breakpoints[size] + 'px)';
  }

  return '&';
};

var columns = exports.columns = 12;

var gutter = exports.gutter = 20;

var containers = exports.containers = {
  xs: false,
  sm: breakpoints.sm,
  md: breakpoints.md,
  lg: breakpoints.lg,
  xl: breakpoints.xl
};

exports.default = {
  columns: columns,
  gutter: gutter,
  breakpoints: breakpoints,
  containers: containers
};


//////////////////
// WEBPACK FOOTER
// ../dist/spec.js
// module id = 44
// module chunks = 0